module.exports = __webpack_public_path__ + "img/icon-indian-big.0998aaf9.svg";